module.exports = __webpack_public_path__ + "static/media/reservoir.9af45483.png";